import { render, staticRenderFns } from "./MaterialEditView.vue?vue&type=template&id=771638c0"
import script from "./MaterialEditView.vue?vue&type=script&lang=js"
export * from "./MaterialEditView.vue?vue&type=script&lang=js"
import style0 from "./MaterialEditView.vue?vue&type=style&index=0&id=771638c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports